module.exports = __webpack_public_path__ + "static/media/menu_color.df7c3203.svg";